import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.tsx';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';
import './index.css';

// Comprehensive startup logging for debugging
console.log('🚀 ChatHTL Starting...');
console.log('⏰ Timestamp:', new Date().toISOString());
console.log('🌐 Hostname:', window.location.hostname);
console.log('📍 URL:', window.location.href);
console.log('📱 User Agent:', navigator.userAgent);
console.log('📝 Environment:', window.ENV?.VITE_ENVIRONMENT || '❌ NOT SET');
console.log('🔗 API URL:', window.ENV?.VITE_API_BASE_URL || '❌ NOT SET');

// Validate configuration
if (!window.ENV) {
  console.error('❌ CRITICAL: window.ENV is not defined! Config file may not be loading.');
} else if (!window.ENV.VITE_API_BASE_URL) {
  console.error('❌ CRITICAL: VITE_API_BASE_URL not configured!');
}

// Check if running in PWA mode
const isPWA = window.matchMedia('(display-mode: standalone)').matches;
console.log('📲 PWA Mode:', isPWA ? 'Yes' : 'No');

// Check service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    console.log('⚙️ Service Workers:', registrations.length, 'registered');
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>
);
